import styled from "styled-components";

export const SeatGridStyled = styled.div`
  .stage {
    margin-bottom: 12px;
    padding: 4px 0;
    border-radius: 6px;
    text-align: center;
    background: ${({ theme }) => theme.COLORS.GRAY_13};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  }
  .grid_wrap {
    overflow-x: auto;
    padding-bottom: 4px;
  }
  .seat_row {
    display: flex;
    align-items: center;
    column-gap: 4px;
    margin-bottom: 4px;
    &.by_col {
      display: grid;
      width: max-content;
      .row_label {
        grid-column: 1;
      }
    }
    .row_label {
      flex-shrink: 0;
      width: 28px;
      text-align: center;
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
  .seat {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: 2px solid transparent;
    border-radius: 6px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    cursor: pointer;
    &.selectable:hover {
      border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
    &.selected {
      border-color: ${({ theme }) => theme.COLORS.PURPLE_4};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.COLORS.PURPLE_5};
      background: ${({ theme }) => theme.COLORS.PURPLE_1} !important;
      color: ${({ theme }) => theme.COLORS.WHITE_1} !important;
    }
  }
`;
